export default __webpack_public_path__ + "static/media/purple_pawn.6a1dea57.png";